import styled from 'styled-components';

/**
 * The pie on the left, the legend taking the rest of the width; on a narrower
 * screen the pie goes on top so the two legend columns keep their room.
 */
export const PieLayout = styled.div`
  display: grid;
  grid-template-columns: 240px minmax(0, 1fr);
  align-items: center;
  gap: 40px;

  @media (max-width: 1100px) {
    grid-template-columns: minmax(0, 1fr);
    justify-items: center;
    gap: 24px;

    > * {
      width: 100%;
    }

    > :first-child {
      max-width: 240px;
    }
  }
`;

/** vDrive and SaaS side by side; stacked on a phone. */
export const ServiceColumns = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
  gap: 24px 40px;

  @media (max-width: 800px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

/** The service name and its subtotal, over its rows. */
export const ServiceHead = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 8px;
  margin-bottom: 4px;
  border-bottom: 1px solid ${({ theme }) => theme.mediumGray};
  font-variant-numeric: tabular-nums;
`;

/** One kind of debt: dot and label (locations under it), amount and share. */
export const KindRow = styled.div`
  display: grid;
  grid-template-columns: 10px minmax(0, 1fr) auto;
  align-items: start;
  column-gap: 10px;
  padding: 8px 0;
  font-variant-numeric: tabular-nums;
`;

export const Dot = styled.span<{ $color: string }>`
  width: 10px;
  height: 10px;
  margin-top: 6px;
  border-radius: 50%;
  background: ${({ $color }) => $color};
`;

/**
 * Every debt ever recorded as one bar: collected, written off, still owed.
 * Each part's width comes in as a percentage of the whole.
 */
export const CollectionBar = styled.div`
  display: flex;
  width: 100%;
  max-width: 420px;
  height: 8px;
  margin-top: 10px;
  border-radius: 4px;
  overflow: hidden;
  background: ${({ theme }) => theme.mediumGray};
`;

export const CollectionPart = styled.span<{ $color: string; $width: number }>`
  width: ${({ $width }) => $width}%;
  background: ${({ $color }) => $color};
`;

/** Collected / written off / still owed under the bar, wrapping on a phone. */
export const CollectionLegend = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  margin-top: 6px;
  font-variant-numeric: tabular-nums;
`;

export const LegendItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const SmallDot = styled.span<{ $color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ $color }) => $color};
`;
